import { TenantConfig } from '../config';
import logo from './neuland.webp';

export const config: TenantConfig = {
    services: ['apartment', 'venue'],
    logo,
    minimumNumberOfDaysForBooking: 2,
    createBookingOptions: ['apartment', 'venue'],
    skipEndingInDays: [],
    invoiceConfig: {
        companyName: 'NEULAND Wohnungsgesellschaft mbH',
        companyNameLines: ['NEULAND', 'Wohnungsgesellschaft mbH'],
        companyAddress: 'Erfurter Ring 15',
        companyZip: '38444',
        companyCity: 'Wolfsburg',
        companyCountry: 'Deutschland',
        taxId: 'DE115244248',
        accountHolder: 'NEULAND Wohnungsgesellschaft mbH',
        bankName: 'Volksbank BraWo',
        iban: 'DE14 2699 1066 0860 6030 00',
        bic: 'GENODEF1WOB',
        companyRegistration: 'Braunschweig HRB 100013',
        managingDirectors:
            'Hans-Dieter Brand (Sprecher der Geschäftsführung), Irina Franz',
        supervisoryBoardChair: 'Immacolata Glosemeyer',
        defaultInvoiceNote:
            'Rechnung am {date} bezahlt und Umsatzsteuer an das '
            + 'Finanzamt Gifhorn abgeführt',
        useCaseSettings: {
            // Gästewohnung (apartment, 7%): fold paid extras into the main
            // position so they aren't shown as separate 19%-looking lines.
            apartment: { bundleExtras: true },
        },
    },
};
